import gql from 'graphql-tag'

export const fetchProductQuery = gql`
  query ($sku: String , $material_type: String) {
    products(filter: { sku: { eq: $sku } , material_type:{ eq: $material_type} },  
    pageSize: 25, currentPage: 1, sort: { default_sort: ASC }) {
      items {
        categories {
          id
          url_key
          name
          products {
            items {
              id
              sku
            }
          }
        }
        alcohol_content
        mwm_discount
        discount_high_markers
        mwm_indicator
        pallet_type
        type_of_packaging_for_one_sku
        ean_per_multipack
        type_of_packaging
        shelf_life
        number_of_multipack_per_pallet
        type_of_packaging
        vat_percent
        returnable_packaging_discount
        disable_for_pallet_ordering_fe
        disable_for_layer_ordering_fe
        total_price
        quantity_selector_layer
        quantity_selector_pallet
        related_products {        
          uid
          name
          sku    
          number_of_products_on_layer
          disable_for_pallet_ordering_fe
          disable_for_layer_ordering_fe
          number_of_products_on_layer
          number_of_layers_per_pallet
          catalog_product_name
          hectolitres_fe
          product_last
          product_new
          product_sale
          product_recommended
          promotional
          favourites
          high_margin
          swatch_image
          your_price
          total_price
          cart_fields {
            packaging_cart
            layer_cart
            pallets_cart
            total_units
          }
          free_beer_details          
          {
            id
            req_id
            qty
            product_id
            free_beer
            iSameFreeProductAlreadyInCart
            disable
            remainingqty
            item_id
          }
          small_image {
            url
          }
          thumbnail {
            url
          }
          image {
            url
          }
          media_gallery {
            url
          }
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
          total_units
        }
        free_beer_details
        {
          id
          req_id
          qty
          product_id
          free_beer
          iSameFreeProductAlreadyInCart
          disable
          remainingqty
          item_id
        }
        special_offer_details{
          max_purchasable_qty
          valid_from
          valid_to
          deliverable_from
          deliverable_to
          deliverable_flag
        }
        low_stock_pl {
          is_lowstock
          out_of_stock
          rotation_day
          quantity
        }
        multi_deposit
        material_type
        number_of_items_in_box
        deliveryDate
        sku
        number_of_products_on_layer
        description {
          html
        }
        ean
        ean_ea
        isavailable_truck_package_ordering
        your_price
        your_price_tax
        unit_price
        downloads_pl{
          title
          url
        }
        favourites
        promo
        weight
        height
        gross_weight_for_one_cas
        other_info_gross_weight
        sap_sub_brand_code
        pallet_weight
        packaging
        options_container
        beer_type
        number_of_layers_per_pallet
        number_of_items_on_pallet
        number_of_products_on_layer
        product_name_sap
        sku_product_detail_page
        brand
        other_info_alcohol
        hectolitres_for_one_cas_frontend
        hectolitres_for_one_cas
        hectolitres_per_pallet
        other_info_shelf_life
        pack_format
        pack_material
        sap_pack
        sap_pack_configuration
        returnable_package
        sub_brand
        volume
        country_of_origin
        catalog_product_name
        name
        filter_packaging
        product_last
        product_new
        product_sale
        product_recommended
        promotional
        high_margin
        canonical_url
        url_path
        url_key
        url_rewrites {
          url
          parameters {
            name
            value
          }
        }
        price_range {
          minimum_price {
            regular_price {
              value
              currency
            }
          }
        }
        swatch_image
        small_image {
          url
        }
        thumbnail {
          url
        }
        image {
          url
        }
        media_gallery {
          url
        }
        cart_fields {
          packaging_cart
          layer_cart
          pallets_cart
        }
        ... on BundleProduct {
          your_price_sum
          your_price_sum_tax
          bundle_price_sum
          bundle_price_sum_tax
          bundle_fields {
            minimum_amt
            valid_from
            valid_to
            limited_amount
          }
          items {
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            bundle_price
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                sku
                sku_product_detail_page
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
      }
      page_info {
        page_size
      }
    }
  }
`
